// extracted by mini-css-extract-plugin
export default {"title":"DietanamnezTiles_title__1NTzC","titleAccent":"DietanamnezTiles_titleAccent__ms-Us"};